var React = require('react');

function Github (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M24 0C10.7 0 0 10.7 0 24c0 10.6 6.9 19.6 16.4 22.8 1.2.2 1.6-.5 1.6-1.2v-4.1c-6.7 1.5-8.1-3.2-8.1-3.2-1.1-2.8-2.7-3.5-2.7-3.5-2.2-1.5.2-1.5.2-1.5 2.4.2 3.7 2.5 3.7 2.5 2.1 3.7 5.6 2.6 7 2 .2-1.6.8-2.6 1.5-3.2-5.3-.6-10.9-2.7-10.9-11.9 0-2.6.9-4.8 2.5-6.4-.2-.6-1.1-3 .2-6.4 0 0 2-.6 6.6 2.5 1.9-.5 4-.8 6-.8s4.1.3 6 .8c4.6-3.1 6.6-2.5 6.6-2.5 1.3 3.3.5 5.7.2 6.4 1.5 1.7 2.5 3.8 2.5 6.4 0 9.2-5.6 11.3-11 11.8.9.7 1.6 2.2 1.6 4.4v6.6c0 .6.4 1.4 1.7 1.2C41.1 43.6 48 34.6 48 24 48 10.7 37.3 0 24 0z"}));
}

Github.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48"};

module.exports = Github;

Github.default = Github;
